module.exports = __webpack_public_path__ + "static/smart-rx-pharmacist-d3857ba28d80758526bad6f512be7cf0.jpg";